import { render, staticRenderFns } from "./SVGCross.vue?vue&type=template&id=22c26399&scoped=true&"
import script from "./SVGCross.vue?vue&type=script&lang=js&"
export * from "./SVGCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c26399",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c26399')) {
      api.createRecord('22c26399', component.options)
    } else {
      api.reload('22c26399', component.options)
    }
    module.hot.accept("./SVGCross.vue?vue&type=template&id=22c26399&scoped=true&", function () {
      api.rerender('22c26399', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGCross.vue"
export default component.exports